import { render, staticRenderFns } from "./HCases.vue?vue&type=template&id=35b4eaa0"
import script from "./HCases.vue?vue&type=script&lang=js"
export * from "./HCases.vue?vue&type=script&lang=js"
import style0 from "./HCases.vue?vue&type=style&index=0&id=35b4eaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports